// Sistema de sons para o Quiz
class SoundManager {
  constructor() {
    this.sounds = {};
    this.enabled = true;
    this.volume = 0.5;
    this.backgroundMusic = null;
    this.musicVolume = 0.3;
  }

  // Criar sons usando Web Audio API (não precisa de arquivos externos)
  createTone(frequency, duration, type = 'sine') {
    if (!this.enabled) return;
    
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.value = frequency;
      oscillator.type = type;
      
      gainNode.gain.setValueAtTime(this.volume, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + duration);
    } catch (error) {
      console.error('Erro ao reproduzir som:', error);
    }
  }

  // Som de acerto - melodia ascendente mágica
  playCorrect() {
    const notes = [523.25, 659.25, 783.99]; // C5, E5, G5
    notes.forEach((freq, index) => {
      setTimeout(() => this.createTone(freq, 0.15, 'sine'), index * 100);
    });
  }

  // Som de erro - tom descendente suave
  playWrong() {
    const notes = [392.00, 329.63]; // G4, E4
    notes.forEach((freq, index) => {
      setTimeout(() => this.createTone(freq, 0.2, 'triangle'), index * 150);
    });
  }

  // Som de clique - tom curto
  playClick() {
    this.createTone(800, 0.05, 'square');
  }

  // Som de vitória - fanfarra
  playVictory() {
    const melody = [
      { freq: 523.25, time: 0 },    // C5
      { freq: 659.25, time: 150 },  // E5
      { freq: 783.99, time: 300 },  // G5
      { freq: 1046.50, time: 450 }, // C6
    ];
    
    melody.forEach(note => {
      setTimeout(() => this.createTone(note.freq, 0.3, 'sine'), note.time);
    });
  }

  // Som de início - tom mágico
  playStart() {
    const notes = [261.63, 329.63, 392.00, 523.25]; // C4, E4, G4, C5
    notes.forEach((freq, index) => {
      setTimeout(() => this.createTone(freq, 0.1, 'sine'), index * 80);
    });
  }

  // Som de progresso - bip suave
  playProgress() {
    this.createTone(1000, 0.08, 'sine');
  }

  // Som ambiente mágico (loop sutil)
  playAmbient() {
    if (!this.enabled) return;
    
    const playAmbientNote = () => {
      const frequencies = [261.63, 329.63, 392.00, 493.88]; // C4, E4, G4, B4
      const randomFreq = frequencies[Math.floor(Math.random() * frequencies.length)];
      this.createTone(randomFreq, 0.5, 'sine');
    };
    
    // Toca uma nota a cada 3-5 segundos
    const interval = setInterval(() => {
      if (this.enabled) {
        playAmbientNote();
      } else {
        clearInterval(interval);
      }
    }, 3000 + Math.random() * 2000);
    
    return interval;
  }

  setVolume(volume) {
    this.volume = Math.max(0, Math.min(1, volume));
  }

  toggle() {
    this.enabled = !this.enabled;
    
    // Pausar ou retomar música de fundo
    if (this.backgroundMusic) {
      if (this.enabled) {
        this.backgroundMusic.play().catch(err => console.log('Erro ao retomar música:', err));
      } else {
        this.backgroundMusic.pause();
      }
    }
    
    return this.enabled;
  }

  setEnabled(enabled) {
    this.enabled = enabled;
    
    // Pausar ou retomar música de fundo
    if (this.backgroundMusic) {
      if (enabled) {
        this.backgroundMusic.play().catch(err => console.log('Erro ao retomar música:', err));
      } else {
        this.backgroundMusic.pause();
      }
    }
  }

  // Iniciar música de fundo
  playBackgroundMusic(audioPath) {
    if (!this.enabled) return;
    
    try {
      // Se já existe uma música tocando, parar
      if (this.backgroundMusic) {
        this.backgroundMusic.pause();
        this.backgroundMusic.currentTime = 0;
      }
      
      // Criar novo elemento de áudio
      this.backgroundMusic = new Audio(audioPath);
      this.backgroundMusic.loop = true;
      this.backgroundMusic.volume = this.musicVolume;
      
      // Tentar tocar (pode falhar se usuário não interagiu ainda)
      this.backgroundMusic.play().catch(err => {
        console.log('Música será reproduzida após interação do usuário');
      });
    } catch (error) {
      console.error('Erro ao reproduzir música de fundo:', error);
    }
  }

  // Parar música de fundo
  stopBackgroundMusic() {
    if (this.backgroundMusic) {
      this.backgroundMusic.pause();
      this.backgroundMusic.currentTime = 0;
      this.backgroundMusic = null;
    }
  }

  // Ajustar volume da música
  setMusicVolume(volume) {
    this.musicVolume = Math.max(0, Math.min(1, volume));
    if (this.backgroundMusic) {
      this.backgroundMusic.volume = this.musicVolume;
    }
  }
}

export const soundManager = new SoundManager();
